import React from 'react';
import { XCircleIcon, ClockIcon, DollarSignIcon } from 'lucide-react';
const Problem = () => {
  return <section className="w-full bg-white py-16" data-id="element-209">
      <div className="container mx-auto px-4" data-id="element-210">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#8B4513] mb-12" data-id="element-211">
          🚨 La razón oculta por la que tus bocaditos no sorprenden{' '}
          <span className="text-[#E25822]" data-id="element-212">(y no es lo que crees)</span>
        </h2>
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-213">
          <p className="text-lg mb-6 text-[#5E4B3C]" data-id="element-214">
            No es tu talento. No es tu tiempo. No eres tú.
          </p>
          <p className="text-lg mb-6 text-[#5E4B3C] font-semibold" data-id="element-215">
            Es el sistema que te enseñaron.
          </p>
          <p className="text-lg mb-6 text-[#5E4B3C]" data-id="element-216">
            Las recetas que usas nunca fueron creadas para impresionar. Solo
            para "cumplir".
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-217">
          <div className="bg-[#F5EBE0] p-6 rounded-lg shadow-md" data-id="element-218">
            <div className="flex items-center mb-4" data-id="element-219">
              <XCircleIcon className="w-10 h-10 text-[#E25822] mr-3" data-id="element-220" />
              <h3 className="text-xl font-bold text-[#8B4513]" data-id="element-221">
                Recetas Incompletas
              </h3>
            </div>
            <p className="text-[#5E4B3C]" data-id="element-222">
              YouTube está lleno de recetas sin medidas exactas, sin
              presentación.
            </p>
          </div>
          <div className="bg-[#F5EBE0] p-6 rounded-lg shadow-md" data-id="element-223">
            <div className="flex items-center mb-4" data-id="element-224">
              <ClockIcon className="w-10 h-10 text-[#E25822] mr-3" data-id="element-225" />
              <h3 className="text-xl font-bold text-[#8B4513]" data-id="element-226">
                Cursos Lentos
              </h3>
            </div>
            <p className="text-[#5E4B3C]" data-id="element-227">
              Los cursos son caros, llenos de teoría inútil para quien necesita
              resultados esta semana.
            </p>
          </div>
          <div className="bg-[#F5EBE0] p-6 rounded-lg shadow-md" data-id="element-228">
            <div className="flex items-center mb-4" data-id="element-229">
              <DollarSignIcon className="w-10 h-10 text-[#E25822] mr-3" data-id="element-230" />
              <h3 className="text-xl font-bold text-[#8B4513]" data-id="element-231">
                Catering Costoso
              </h3>
            </div>
            <p className="text-[#5E4B3C]" data-id="element-232">
              Pedir catering te roba el alma. Cuando alguien dice "wow, ¿quién
              hizo esto?" y respondes: "lo encargué"... algo en ti se apaga.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default Problem;